import { render, staticRenderFns } from "./FeriadosPage.vue?vue&type=template&id=574041a6"
import script from "./FeriadosPage.vue?vue&type=script&lang=js"
export * from "./FeriadosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports